module.exports = __webpack_public_path__ + "images/Banner3c72d51eae252c639bbcd0dbd7a4ea10d.svg";